import React from 'react'
import DummyPoint from './DummyPoint'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'

// IMPORT REDUX ACTIONS
import * as AnalyticsActions from '../../../../actions/analytics'

const DummyCollection = (props) => {

    return (
        <div>
            {props.sensors.map((data, key) => (
            <DummyPoint
                onClick={() => {
                    props.analyticsActions.fetchHistoric(data.location.coordinates)
                    props.analyticsActions.removeAQI()
                }}
                isAdmin={props.isAdmin}
                key={key}
                data={data}
                arrayIndex={props.sensors.indexOf(data)}
                timestampValue={data.timestampValue}
                map={props.map}
                zoom={props.zoom}
            />
            ))}
        </div>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        analyticsActions: bindActionCreators(AnalyticsActions, dispatch),
    }
};

export default connect(null, mapDispatchToProps)(DummyCollection)



// WEBPACK FOOTER //
// ./src/components/Map/MapComponents/sensors/DummyCollection.js